import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { MyNoiseGradadientBackground } from "../../components/backgrounds";
import { MyButton } from "../../components/MyButton";
import {
  logFormStart,
  logFormSubmit,
  setFirbaseUserProperties,
} from "../../services/firebase/analytics";
import { useTranslation } from "react-i18next";

export const ContactForm: React.FC<{
  sectionRef: React.RefObject<HTMLDivElement>;
}> = ({ sectionRef }) => {
  const { t } = useTranslation();
  const [hasStartedFilling, setHasStartedFilling] = useState(false);

  const handleFormStart = () => {
    if (!hasStartedFilling) {
      logFormStart("contact_form");
      setHasStartedFilling(true);
    }
  };

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const email = formData.get("email") as string;
    const name = formData.get("name") as string;
    const message = formData.get("message") as string;

    setFirbaseUserProperties({
      user_email: email,
      user_name: name,
    });

    logFormSubmit("contact_form");

    // Send to n8n webhook via Netlify Function
    try {
      const response = await fetch("/.netlify/functions/contact-webhook", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          message,
        }),
      });
      
      if (!response.ok) {
        const error = await response.json();
        console.error("Webhook error:", error);
      } else {
        const result = await response.json();
        console.log("✅ Webhook success:", result);
      }
    } catch (error) {
      console.error("Error sending to webhook:", error);
    }

    // Redirect to success page
    window.location.href = "/contact/success";

    // DEACTIVATED: Submit to web3forms (uncomment to reactivate email submission)
    // form.submit();
  };

  return (
    <div className="contact__section py-5 section-container" ref={sectionRef}>
      <MyNoiseGradadientBackground rotate />
      <h1
        className="section-title"
        style={{ paddingTop: "7rem", paddingBottom: "3rem" }}
      >
        {t('landing:contact.title')}
      </h1>

      <div className="contact-container">
        {/* DEACTIVATED: web3forms submission - to reactivate add: action="https://api.web3forms.com/submit" method="POST" */}
        <form onSubmit={onSubmit}>
        <img src="/assets/gifs/chat-bot.gif" alt="contact" />
        {/* DEACTIVATED: web3forms hidden inputs - uncomment to reactivate */}
        {/* <input
          type="hidden"
          name="access_key"
          value="0ed70122-2728-4c46-afe2-02f44b3a674f"
        />
        <input
          type="hidden"
          name="redirect"
          value="https://www.effai.it/contact/success"
        /> */}

        <div className="mb-3">
          <label className="form-label">{t('landing:contact.form.nameLabel')}</label>
          <input
            placeholder={t('landing:contact.form.namePlaceholder')}
            type="text"
            name="name"
            className="form-control"
            required
            onFocus={handleFormStart}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">{t('landing:contact.form.emailLabel')}</label>
          <input
            placeholder={t('landing:contact.form.emailPlaceholder')}
            type="email"
            name="email"
            className="form-control"
            required
            onFocus={handleFormStart}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">{t('landing:contact.form.messageLabel')}</label>
          <textarea
            name="message"
            placeholder={t('landing:contact.form.messagePlaceholder')}
            className="form-control"
            required
            onFocus={handleFormStart}
          ></textarea>
        </div>

        <div className="mb-3" style={{ color: "white" }}>
        {t('landing:contact.form.privacyPolicy')}
        </div>

        <MyButton isSubmit className="w-100">
          {t('landing:contact.form.submitBtn')}
        </MyButton>
      </form>
      </div>
    </div>
  );
};
